import axiosInstance from '../utils/AxiosConfig';

class ObjectivesService {
  // Objetivos generales
  async getObjectives() {
    try {
      console.log('[ObjectivesService] GET /objectives - Request');
      const response = await axiosInstance.get('/objectives');
      console.log('[ObjectivesService] GET /objectives - Response:', response.data);
      return response.data.data || [];
    } catch (error) {
      console.error('[ObjectivesService] GET /objectives - Error:', error);
      console.error('[ObjectivesService] GET /objectives - Error Response:', error.response?.data);
      throw error;
    }
  }

  async getObjectiveById(id) {
    try {
      console.log(`[ObjectivesService] GET /objectives/${id} - Request`);
      const response = await axiosInstance.get(`/objectives/${id}`);
      console.log(`[ObjectivesService] GET /objectives/${id} - Response:`, response.data);
      return response.data.data;
    } catch (error) {
      console.error(`[ObjectivesService] GET /objectives/${id} - Error:`, error);
      console.error(`[ObjectivesService] GET /objectives/${id} - Error Response:`, error.response?.data);
      throw error;
    }
  }

  async createObjective(objective) {
    try {
      const requestData = {
        title: objective.title,
        description: objective.description,
        category: objective.category
      };
      
      // Incluir default_target_value solo si tiene un valor (no null, no undefined)
      if (objective.default_target_value !== null && objective.default_target_value !== undefined) {
        requestData.default_target_value = objective.default_target_value;
      }
      
      console.log('[ObjectivesService] POST /objectives - Request:', requestData);
      const response = await axiosInstance.post('/objectives', requestData);
      console.log('[ObjectivesService] POST /objectives - Response:', response.data);
      return response.data.data;
    } catch (error) {
      console.error('[ObjectivesService] POST /objectives - Error:', error);
      console.error('[ObjectivesService] POST /objectives - Error Response:', error.response?.data);
      throw error;
    }
  }

  async updateObjective(id, objective) {
    try {
      const requestData = {
        title: objective.title,
        description: objective.description,
        category: objective.category
      };
      
      // Incluir default_target_value solo si tiene un valor (no null, no undefined)
      if (objective.default_target_value !== null && objective.default_target_value !== undefined) {
        requestData.default_target_value = objective.default_target_value;
      }
      
      console.log(`[ObjectivesService] PUT /objectives/${id} - Request:`, requestData);
      const response = await axiosInstance.put(`/objectives/${id}`, requestData);
      console.log(`[ObjectivesService] PUT /objectives/${id} - Response:`, response.data);
      return response.data.data;
    } catch (error) {
      console.error(`[ObjectivesService] PUT /objectives/${id} - Error:`, error);
      console.error(`[ObjectivesService] PUT /objectives/${id} - Error Response:`, error.response?.data);
      throw error;
    }
  }

  async deleteObjective(id) {
    try {
      console.log(`[ObjectivesService] DELETE /objectives/${id} - Request`);
      const response = await axiosInstance.delete(`/objectives/${id}`);
      console.log(`[ObjectivesService] DELETE /objectives/${id} - Response:`, response.data);
      return response.data;
    } catch (error) {
      console.error(`[ObjectivesService] DELETE /objectives/${id} - Error:`, error);
      console.error(`[ObjectivesService] DELETE /objectives/${id} - Error Response:`, error.response?.data);
      throw error;
    }
  }

  // Objetivos mensuales
  async getMonthlyObjectives(year, month) {
    try {
      console.log(`[ObjectivesService] GET /objectives/monthly?year=${year}&month=${month} - Request`);
      const response = await axiosInstance.get(`/objectives/monthly?year=${year}&month=${month}`);
      console.log(`[ObjectivesService] GET /objectives/monthly - Response:`, response.data);
      return response.data.data || { year, month, objectives: [] };
    } catch (error) {
      console.error(`[ObjectivesService] GET /objectives/monthly - Error:`, error);
      console.error(`[ObjectivesService] GET /objectives/monthly - Error Response:`, error.response?.data);
      throw error;
    }
  }

  // Obtener todos los objetivos mensuales de un año (nuevo endpoint optimizado)
  async getYearlyMonthlyObjectives(year) {
    try {
      console.log(`[ObjectivesService] GET /objectives/monthly?year=${year} - Request`);
      const response = await axiosInstance.get(`/objectives/monthly?year=${year}`);
      console.log(`[ObjectivesService] GET /objectives/monthly (yearly) - Response:`, response.data);
      return response.data.data || { year, objectives: [] };
    } catch (error) {
      console.error(`[ObjectivesService] GET /objectives/monthly (yearly) - Error:`, error);
      console.error(`[ObjectivesService] GET /objectives/monthly (yearly) - Error Response:`, error.response?.data);
      throw error;
    }
  }

  async assignMonthlyObjective(monthlyObjective) {
    try {
      const requestData = {
        year: monthlyObjective.year,
        month: monthlyObjective.month,
        objective_id: monthlyObjective.objective_id,
        target_value: monthlyObjective.target_value
      };
      console.log('[ObjectivesService] POST /objectives/monthly - Request:', requestData);
      const response = await axiosInstance.post('/objectives/monthly', requestData);
      console.log('[ObjectivesService] POST /objectives/monthly - Response:', response.data);
      return response.data.data;
    } catch (error) {
      console.error('[ObjectivesService] POST /objectives/monthly - Error:', error);
      console.error('[ObjectivesService] POST /objectives/monthly - Error Response:', error.response?.data);
      throw error;
    }
  }

  async deleteMonthlyObjective(id) {
    try {
      console.log(`[ObjectivesService] DELETE /objectives/monthly/${id} - Request`);
      const response = await axiosInstance.delete(`/objectives/monthly/${id}`);
      console.log(`[ObjectivesService] DELETE /objectives/monthly/${id} - Response:`, response.data);
      return response.data;
    } catch (error) {
      console.error(`[ObjectivesService] DELETE /objectives/monthly/${id} - Error:`, error);
      console.error(`[ObjectivesService] DELETE /objectives/monthly/${id} - Error Response:`, error.response?.data);
      throw error;
    }
  }

  // Asignaciones de objetivos
  async getObjectiveAssignments(objectiveId) {
    try {
      console.log(`[ObjectivesService] GET /objectives/${objectiveId}/assignments - Request`);
      const response = await axiosInstance.get(`/objectives/${objectiveId}/assignments`);
      console.log(`[ObjectivesService] GET /objectives/${objectiveId}/assignments - Response:`, response.data);
      return response.data.data || [];
    } catch (error) {
      console.error(`[ObjectivesService] GET /objectives/${objectiveId}/assignments - Error:`, error);
      console.error(`[ObjectivesService] GET /objectives/${objectiveId}/assignments - Error Response:`, error.response?.data);
      throw error;
    }
  }

  async assignObjective(assignment) {
    try {
      const requestData = {
        objective_id: assignment.objective_id,
        scope: assignment.scope,
        branch_id: assignment.branch_id,
        user_id: assignment.user_id,
        month: assignment.month,
        year: assignment.year,
        target_value: assignment.target_value
      };
      console.log('[ObjectivesService] POST /objectives/assignments - Request:', requestData);
      const response = await axiosInstance.post('/objectives/assignments', requestData);
      console.log('[ObjectivesService] POST /objectives/assignments - Response:', response.data);
      return response.data.data;
    } catch (error) {
      console.error('[ObjectivesService] POST /objectives/assignments - Error:', error);
      console.error('[ObjectivesService] POST /objectives/assignments - Error Response:', error.response?.data);
      throw error;
    }
  }

  async deleteObjectiveAssignment(assignmentId) {
    try {
      console.log(`[ObjectivesService] DELETE /objectives/assignments/${assignmentId} - Request`);
      const response = await axiosInstance.delete(`/objectives/assignments/${assignmentId}`);
      console.log(`[ObjectivesService] DELETE /objectives/assignments/${assignmentId} - Response:`, response.data);
      return response.data;
    } catch (error) {
      console.error(`[ObjectivesService] DELETE /objectives/assignments/${assignmentId} - Error:`, error);
      console.error(`[ObjectivesService] DELETE /objectives/assignments/${assignmentId} - Error Response:`, error.response?.data);
      throw error;
    }
  }
}

export default new ObjectivesService();

